import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { selectFromConfig } from '@gandi/redux-config';
import { selectCurrentId } from '@gandi/redux-sharing';
import { withTranslator } from '@gandi/translate';
import Presenter from '../components/PaymentReturn';
import { selectOrder, fetchOrder } from '../modules/orders';
import { fetchLastPrepaid, selectPrepaid } from '../modules/prepaid';
function isPrepaidRefill(order) {
  return order.type === 'refill_prepaid';
}
const selectAdminURL = selectFromConfig('app.layout.urls.admin', 'https://admin.gandi.net');
// $FlowFixMe[missing-local-annot]
const mapStateToProps = (state, {
  orderId
}) => {
  const order = orderId ? selectOrder(state, {
    orderId
  }) : undefined;
  const sharingId = selectCurrentId(state);
  const prepaid = selectPrepaid(state, {
    sharingId
  });
  const prepaidBalance = order && isPrepaidRefill(order) && order.status === 'done' ? prepaid && typeof prepaid.amount === 'number' ? prepaid.amount : Number.NaN : undefined;
  return {
    sharingId,
    order,
    adminURL: selectAdminURL(state),
    prepaidBalance
  };
};
async function preFetch(args) {
  const orderId = args.orderId;
  if (!orderId) {
    throw new Error('PaymentReturn Container preFetch called without ?order querystring');
  }
  await args.dispatch(fetchOrder(orderId));

  // $FlowFixMe[prop-missing] --- we should discuss it+
  const order = selectOrder(args.getState(), {
    orderId
  });
  if (!order) {
    return;
  }
  const status = order.status;
  if (isPrepaidRefill(order) && status === 'done') {
    // $FlowFixMe[prop-missing] --- we should discuss it
    const sharingId = selectCurrentId(args.getState());
    await args.dispatch(fetchLastPrepaid(sharingId));
  }
}
const PaymentReturn = compose(withTranslator({
  propsNamespace: 'translator'
}), connect(mapStateToProps)
// $FlowFixMe[unclear-type]
)(Presenter);
PaymentReturn.preFetch = preFetch;
export default PaymentReturn;